export const contactDetailsPayload = [
  "HEB_CONTACT_US_PHONE",
  "HEB_CONTACT_US_EMAIL",
];

export const ERROR_CODES = {
  DATA_NOT_FOUND: 20001,
  EXTERNAL_SERVICE_AVAILABLE: 30001,
  DUPLICATE_SOURCE: 20002,
  INTERNAL_SERVER_ERROR: 40001,
  VALIDATION_ERROR: 10001,
  SUCCESS: 90000,
};
export const Path = {
  HOME: "/",
  MORTGAGE: "/mortgage",
  DOCUMENTS: "/documents",
  PROFILE: "/profile",
  CONTACT_US: "/contactus",
};
